/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Seo_Keywords_CsInputs */

const cs_form_seo_keywords_cs = /** @type {(inputs: Form_Seo_Keywords_CsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SEO klíčová slova (CS)`)
};

const en_form_seo_keywords_cs = /** @type {(inputs: Form_Seo_Keywords_CsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SEO keywords (CS)`)
};

/**
* | output |
* | --- |
* | "SEO keywords (CS)" |
*
* @param {Form_Seo_Keywords_CsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_seo_keywords_cs = /** @type {((inputs?: Form_Seo_Keywords_CsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Seo_Keywords_CsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_seo_keywords_cs(inputs)
	return cs_form_seo_keywords_cs(inputs)
});